import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteOrgStructureAssignment as apiFn } from "../../api/apiOrgStructureAssignments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteOrgStructureAssignment() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: deleteAssignment, isPending: isDelete } = useMutation({
        mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["orgStructureAssignments"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { deleteAssignment, isDelete };
}
